import React, { useEffect, useState } from "react";
import { createWebinarInfo } from "../../../SchemaInfo/info";
import { createWebinarSchema } from "../../../Schemas/webinar/create_webinar";
import { Form, Formik } from "formik";
import CustomInput from "../../../CustomComponent/custom_input";
import SimpleButton from "../../../Components/layouts/simple_button";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import performRequest from "../../../api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { useNavigate, useParams } from "react-router";
import { Toast } from "../../../CustomComponent/toast";

const EditWebinar = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [editWebinarinfo, setEditWebinarInfo] = useState(createWebinarInfo);
  useEffect(() => {
    performRequest("GET", `/webinar/getwebinarById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setEditWebinarInfo(res.data);
        }
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          Toast("error", err?.response?.data?.message);
        } else {
          CustomErrorResponse(err);
        }
      });
  }, []);

  const CheckhandelSubmit = (values) => {
    const formData = new FormData();

    for (let key in values) {
      if (Array.isArray(values[key])) {
        values[key].forEach((item) => formData.append(`${key}[]`, item));
      } else {
        formData.append(key, values[key]);
      }
    }

    performRequest("PATCH", `/webinar/editwebinar/${id}`, formData, {
      "Content-Type": "multipart/form-data",
    })
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Webinar Updated Successfully");
          navigate("/all-webinars");
        }
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          Toast("error", err?.response?.data?.message);
        } else {
          CustomErrorResponse(err);
        }
      });
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div style={{ minHeight: "80vh" }}>
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row g-2 align-items-center mb-5 mb-md-0 mb-lg-0">
                <div className="card  mb-5 mb-md-0 mb-lg-0">
                  <Formik
                    initialValues={editWebinarinfo}
                    validationSchema={createWebinarSchema}
                    enableReinitialize
                    onSubmit={CheckhandelSubmit}
                  >
                    {(props) => (
                      <Form>
                        <>
                          <h2 className="m-0 p-2">Edit Webinar Details</h2>
                          <hr className="my-1" />
                          <div className="row p-4">
                            <div className="mb-3 row">
                              <label className="form-label col-lg-3">
                                Webinar Name
                              </label>
                              <div className="col-lg-9">
                                {" "}
                                <CustomInput
                                  name="webinarName"
                                  type="text"
                                  placeholder="Enter Webinar Name"
                                />
                                {props.touched.webinarName &&
                                  props.errors.webinarName && (
                                    <p className="text-danger">
                                      {props.errors.webinarName}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="form-label col-lg-3">
                                Description
                              </label>
                              <div className="col-lg-9">
                                {" "}
                                <CustomTextArea
                                  name="description"
                                  type="text"
                                  placeholder="Enter Webinar Descriptiton"
                                />
                                {props.touched.description &&
                                  props.errors.description && (
                                    <p className="text-danger">
                                      {props.errors.description}
                                    </p>
                                  )}
                              </div>
                            </div>

                            <div className="mb-3 row">
                              <label className="form-label col-lg-3">
                                Thumbnail
                              </label>
                              <div className="col-lg-9">
                                {" "}
                                <CustomInput
                                  name="webinarThumbnail"
                                  type="file"
                                  onChange={(e) =>
                                    props.setFieldValue(
                                      "webinarThumbnail",
                                      e.target.files[0]
                                    )
                                  }
                                  placeholder="Enter Thumbnail URL"
                                />
                                {props.touched.webinarThumbnail &&
                                  props.errors.webinarThumbnail && (
                                    <p className="text-danger">
                                      {props.errors.webinarThumbnail}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="form-label col-lg-3">
                                Speaker Info
                              </label>
                              <div className="col-lg-9">
                                {" "}
                                <CustomInput
                                  name="speakerInfo"
                                  type="text"
                                  placeholder="Enter Speaker Name"
                                />
                                {props.touched.speakerInfo &&
                                  props.errors.speakerInfo && (
                                    <p className="text-danger">
                                      {props.errors.speakerInfo}
                                    </p>
                                  )}
                              </div>
                            </div>

                            <div className="mb-3 row">
                              <label className="form-label col-lg-3">
                                Webinar Date
                              </label>
                              <div className="col-lg-9">
                                <CustomInput
                                  name="webinarDate"
                                  type="date"
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (value) {
                                      const day = new Date(value).getDay();
                                      if (day !== 0 && day !== 6) {
                                        props.setFieldValue("webinarDate", ""); // Clear if not weekend
                                        return;
                                      }
                                    }
                                    props.setFieldValue("webinarDate", value);
                                  }}
                                />

                                {props.touched.webinarDate &&
                                props.errors.webinarDate ? (
                                  <p className="text-danger">
                                    {props.errors.webinarDate}{" "}
                                    <p className="text-muted mt-1">
                                      Only Saturdays and Sundays can be
                                      selected.
                                    </p>
                                  </p>
                                ) : (
                                  <p className="text-muted mt-1">
                                    Only Saturdays and Sundays can be selected.
                                  </p>
                                )}
                              </div>
                            </div>

                            <div className="mb-3 row">
                              <label className="form-label col-lg-3">
                                Start Time
                              </label>
                              <div className="col-lg-9">
                                <CustomInput
                                  type="text"
                                  name="webinarStartTime"
                                  placeholder="e.g. 2:15 PM"
                                  pattern="^(0?[1-9]|1[0-2]):[0-5][0|5] (AM|PM)$"
                                  disabled
                                />

                                {props.touched.webinarStartTime &&
                                  props.errors.webinarStartTime && (
                                    <p className="text-danger">
                                      {props.errors.webinarStartTime}
                                    </p>
                                  )}
                              </div>
                            </div>

                            <div className="mb-3 row">
                              <label className="form-label col-lg-3">
                                End Time
                              </label>
                              <div className="col-lg-9">
                                <CustomInput
                                  type="text"
                                  name="webinarEndTime"
                                  placeholder="e.g. 2:15 PM"
                                  pattern="^(0?[1-9]|1[0-2]):[0-5][0|5] (AM|PM)$"
                                  disabled
                                />

                                {props.touched.webinarEndTime &&
                                  props.errors.webinarEndTime && (
                                    <p className="text-danger">
                                      {props.errors.webinarEndTime}
                                    </p>
                                  )}
                              </div>
                            </div>
                          </div>
                        </>

                        <div className="card-footer mt-4">
                          <div className="btn-list justify-content-end">
                            <FormSubmitButton buttonText="Submit" />
                            <SimpleButton
                              buttonText="Cancel"
                              type="secondary"
                            />
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditWebinar;
